module.exports = __webpack_public_path__ + "static/instagram-2fa21f6fce030076be9d89dd85496a56.svg";